export default __webpack_public_path__ + "static/media/Roboto-Italic.c25fbd68.woff";